var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLista(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "234.334px",
    height: "48px",
    viewBox: "0 0 234.334 48",
    enableBackground: "new 0 0 234.334 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.819,
    y: 4.43,
    fill: "#002455",
    width: 39.036,
    height: 11.099
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.819,
    y: 18.372,
    fill: "#004C90",
    width: 39.036,
    height: 11.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.819,
    y: 32.367,
    fill: "#008AD2",
    width: 39.036,
    height: 11.099
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.677,43.466 89.32,43.466 89.32,36.183 70.677,36.183 70.677,4.429 57.18,4.429 57.18,43.466  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.323,
    y: 4.43,
    width: 13.497,
    height: 39.036
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.105,4.429 155.011,4.429 155.011,11.713 166.811,11.713 166.811,43.466 180.307,43.466 180.307,11.713  192.105,11.713  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.079,43.466h14.436L215.354,4.43h-5.773l0.003-0.009l-7.843,0.009l-14.795,39.036h8.258l2.432-6.604h16.075 L216.079,43.466z M200.21,29.869l5.57-15.123l5.425,15.123H200.21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.233,15.911c-0.285-3.168-1.868-6.269-7.707-6.277c-4.387-0.005-6.461,2.391-6.273,4.986 c0.096,1.291,0.875,2.491,2.648,2.964c2.988,0.796,9.135,1.828,12.636,2.526c9.709,1.931,13.829,5.488,13.829,11.822 c0,12.615-15.246,13.288-20.723,13.297c-12.162,0.02-20.938-3.213-21.639-13.947h13.501c0.105,3.377,2.13,6.962,8.688,6.984 c3.652,0.014,6.716-2.343,6.607-5.595c-0.068-2.048-1.195-3.146-4.25-3.858c-2.599-0.606-11.188-1.92-13.664-2.473 c-7.229-1.614-10.28-5.635-10.28-10.644c0-5.071,2.928-12.927,18.622-12.927c12.99,0,20.793,4.026,21.547,13.141H140.233"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLista);
export default __webpack_public_path__ + "static/media/LISTA.1f4d1db893c4970d8e5c316942a6246c.svg";
export { ForwardRef as ReactComponent };